import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=b0a2fb68&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a2fb68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0a2fb68')) {
      api.createRecord('b0a2fb68', component.options)
    } else {
      api.reload('b0a2fb68', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=b0a2fb68&scoped=true", function () {
      api.rerender('b0a2fb68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/detail.vue"
export default component.exports